import { createAction, props } from '@ngrx/store';

import { Customer, CustomerLocation } from '../../shared/models/shared.model';
import {
  AccessRule,
  Application,
  ApplicationGroup,
  Contactperson,
  NewRole,
} from '../models/contactperson.model';

export const searchContactpersons = createAction(
  '[Contactperson] Search Contactpersons',
  props<{ searchtext: string }>(),
);
export const clearContactpersons = createAction('[Contactperson] Clear Contactpersons');
export const getContactpersonsRequest = createAction(
  '[Contactperson] Get Contactpersons',
  props<{ searchtext: string }>(),
);
export const getContactpersonsError = createAction(
  '[Contactperson] Get Contactpersons Error',
  props<{ error: Error }>(),
);
export const getContactpersonsSuccess = createAction(
  '[Contactperson] Get Contactpersons Success',
  props<{ contactPersons: Contactperson[] }>(),
);
export const setSelectedContactpersonId = createAction(
  '[Contactperson] Set selected contactperson id',
  props<{ contactpersonId?: number }>(),
);
export const setSelectedContactperson = createAction(
  '[Contactperson] Set selected contactperson',
  props<{ contactperson: Contactperson }>(),
);
export const loadContactpersonsRequest = createAction(
  '[Contactperson] Load Contactpersons request',
);
export const upsertContactpersonRequest = createAction(
  '[Contactperson] Upsert Contactperson request',
  props<{ contactperson: Contactperson }>(),
);
export const upsertContactpersonSuccess = createAction(
  '[Contactperson] Upsert Contactperson success',
  props<{ contactperson: Contactperson }>(),
);
export const upsertContactpersonError = createAction(
  '[Contactperson] Upsert Contactperson Error',
  props<{ error: Error }>(),
);
export const searchCustomersforRelation = createAction(
  '[Contactperson] Search Customers for Relation',
  props<{ searchtext: string }>(),
);
export const clearCustomerRelationSearchbox = createAction(
  '[Contactperson] Clear Customer Relation Searchbox',
);
export const getCustomersforSearchboxRequest = createAction(
  '[Contactperson] Get Customers for Searchbox Request',
  props<{ searchtext: string }>(),
);
export const getCustomersforSearchboxError = createAction(
  '[Contactperson] Get Customers for Searchbox Error',
  props<{ error: Error }>(),
);
export const getCustomersforSearchboxSuccess = createAction(
  '[Contactperson] Get Customers for Searchbox Success',
  props<{ customers: Customer[] }>(),
);
export const getCustomerRelationsRequest = createAction(
  '[Contactperson] Get Customer Relations Request',
  props<{ id: number }>(),
);
export const getCustomerRelationsSuccess = createAction(
  '[Contactperson] Get Customer Relations Success',
  props<{ customers: Customer[] }>(),
);
export const getCustomerRelationsError = createAction(
  '[Contactperson] Get Customer Relations Error',
  props<{ error: Error }>(),
);
export const getLocationsForRelationWithCustomerRequest = createAction(
  '[Contactperson] Get Locations for Relation with Customer Request',
  props<{ customerId: number; contactpersonId: number }>(),
);
export const getLocationsForRelationWithCustomerSuccess = createAction(
  '[Contactperson] Get Locations for Relation with Customer Success',
  props<{ locations: CustomerLocation[] }>(),
);
export const getLocationsForRelationWithCustomerError = createAction(
  '[Contactperson] Get Locations for Relation with Customer Error',
  props<{ error: Error }>(),
);
export const setRelationWithLocationRequest = createAction(
  '[Contactperson] Set Relation with Location Request',
  props<{ contactpersonId: number; customerId: number; locationIds: Array<number> }>(),
);
export const setRelationWithLocationError = createAction(
  '[Contactperson] Set Relation with Location Error',
  props<{ error: Error }>(),
);
export const initAuthorization = createAction(
  '[Contactperson] Init authorization',
  props<{ externalId: string }>(),
);
export const setProfileId = createAction(
  '[Contactperson] Set profile id',
  props<{ profileId: number }>(),
);
export const selectApplicationGroups = createAction('[Contactperson] Select application groups');
export const setApplications = createAction(
  '[Contactperson] Set applications',
  props<{ applications: Application[] }>(),
);
export const setApplicationGroups = createAction(
  '[Contactperson] Set application groups',
  props<{ applicationGroups: ApplicationGroup[] }>(),
);
export const setRoles = createAction('[Contactperson] Set roles', props<{ roles: NewRole[] }>());
export const setAccessRules = createAction(
  '[Contactperson] Set access rules',
  props<{ accessRules: AccessRule[] }>(),
);
export const deleteGroupUseraccess = createAction(
  '[Contactperson] Delete group user access',
  props<{ groupId: number }>(),
);
export const deleteGroupUseraccessSuccess = createAction(
  '[Contactperson] Delete group user access success',
  props<{ groupId: number }>(),
);
export const setUseraccess = createAction(
  '[Contactperson] Set user access',
  props<{ applicationKey: string; roleKey: string }>(),
);
export const setGroupUseraccess = createAction(
  '[Contactperson] Set group user access',
  props<{ groupId: number }>(),
);
export const clearSelectedContactperson = createAction(
  '[Contactperson] Clear selected contact person',
);
